import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShieldCheck, ArrowUpRight, MessageCircle, FileText, Pen } from "lucide-react";
import { PHOTO_INVENTORY } from "../lib/constants";

export default function SocialLanding() {
  return (
    <div data-testid="social-landing" className="py-20">
      <section className="relative h-[40vh] min-h-[320px] flex items-end overflow-hidden -mt-20 mb-16">
        <img src={PHOTO_INVENTORY} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-forest-900 via-forest-900/60 to-forest-900/30" />
        <div className="container-page relative pb-12 text-cream-100">
          <div className="eyebrow !text-copaiba-300 mb-3">Setor Social</div>
          <h1 className="font-display text-5xl md:text-6xl leading-[1.02] max-w-3xl">
            Apoio social <span className="italic text-copaiba-300">próximo</span> de cada cooperado e comunidade.
          </h1>
        </div>
      </section>

      <div className="container-page grid md:grid-cols-2 gap-6 mb-16">
        <Link to="/setor-social/solicitar" data-testid="social-request-card" className="card-earthy block p-8 group">
          <Heart className="w-8 h-8 text-copaiba-700 mb-5" />
          <h2 className="font-display text-2xl text-forest-900">Fazer uma solicitação</h2>
          <p className="text-forest-900/75 mt-3 text-sm leading-relaxed">
            Cooperados, comunidades e instituições podem solicitar apoio do Setor Social da COOMFLONA. Você recebe um
            <strong> número de protocolo</strong> e um <strong>link para assinar o termo no celular</strong>.
          </p>
          <span className="mt-5 inline-flex items-center gap-1 text-sm text-forest-700 group-hover:text-copaiba-700">
            Abrir formulário <ArrowUpRight className="w-4 h-4" />
          </span>
        </Link>

        <Link to="/setor-social/login" data-testid="social-login-card" className="bg-forest-700 text-cream-100 block p-8 group hover:bg-forest-900 transition-colors">
          <ShieldCheck className="w-8 h-8 text-copaiba-300 mb-5" />
          <h2 className="font-display text-2xl">Acesso restrito</h2>
          <p className="text-cream-100/80 mt-3 text-sm leading-relaxed">
            Área exclusiva para a <strong>Elen Samara</strong>, responsável pelo Setor Social — acompanhar solicitações,
            mudar status, gerar termos em PDF e emitir relatórios em Excel.
          </p>
          <span className="mt-5 inline-flex items-center gap-1 text-sm text-copaiba-300 group-hover:text-copaiba-500">
            Entrar <ArrowUpRight className="w-4 h-4" />
          </span>
        </Link>
      </div>

      <div className="container-page grid md:grid-cols-3 gap-4 mb-16 max-w-5xl">
        <Feature icon={<FileText className="w-5 h-5" />} title="Protocolo automático">
          Cada solicitação gera um número único <span className="font-mono text-xs">COOMFLONA-DDMMYYYY-NNNN</span> para acompanhamento.
        </Feature>
        <Feature icon={<Pen className="w-5 h-5" />} title="Assinatura no celular">
          O solicitante assina o termo com o dedo, pelo link enviado por WhatsApp.
        </Feature>
        <Feature icon={<MessageCircle className="w-5 h-5" />} title="Contato direto">
          Elen Samara · Setor Social — WhatsApp <strong>(93) 99149-3368</strong>.
        </Feature>
      </div>

      <div className="container-page max-w-3xl text-center">
        <p className="text-forest-900/75 leading-relaxed">
          O Setor Social organiza pedidos de apoio de cooperados, não cooperados, comunidades e instituições parceiras
          da COOMFLONA. Tudo é registrado, acompanhado e respondido com transparência pela nossa equipe.
        </p>
      </div>
    </div>
  );
}

function Feature({ icon, title, children }) {
  return (
    <div className="bg-white border border-cream-400 p-5">
      <div className="w-9 h-9 rounded-full bg-forest-700 text-cream-100 flex items-center justify-center mb-3">{icon}</div>
      <div className="font-display text-lg text-forest-900">{title}</div>
      <p className="text-sm text-forest-900/75 mt-1 leading-relaxed">{children}</p>
    </div>
  );
}
